export default __webpack_public_path__ + "static/media/triangles.855f42e5.svg";